export const phoneWidth: number = 550;
export const tabletWidth: number = 834;
export const mediumTabletWidth: number = 960;
export const wideTabletWidth: number = 1024;
export const shortDesktopWidth: number = 1280;
export const fhdWidth: number = 1920;
export const hdWidth: number = 1366;
